export default __webpack_public_path__ + "static/google_play-6577102c4652d967d71512a19b153512.svg";